<template>
    <div class="col-12 mt-3 mb-md-3">
        <div class="card">
            <router-link :to="{ name: 'item-details', params: { itemTitle: item.title, itemId: item._id } }" :title="`${item.title} - aNewItem.com`">
                <!-- import item photo here -->
                <div class="row">
                    <div class="col-12">
                        <app-item-photo class="anewitem-shipping-img rounded" :itemPhotos="item.photos" :hdQuality="true"></app-item-photo>
                    </div>
                </div>
                
                <!-- display item title here -->
                <div class="row">
                    <div class="col-12">
                        <div class="p-1">
                            <p class="anewitem-shipping-title m-0"><i class="far fa-image"></i> {{item.title}}</p>
                        </div>
                    </div>
                </div>
            </router-link>

            <!-- display item shipping methods after loading local currency -->
            <div v-if="theCurrency" class="row mt-n1">
                <div class="col-12">
                    <div class="p-1">
                        <p class="my-1 font-weight-bold">
                            <i class="fas fa-shipping-fast fa-sm"></i> <span class="text-dark-green">SELECT SHIPPING METHOD</span>
                        </p>
                        <div class="table-responsive bg-light anewitem-shipping-table">
                            <table class="table table-striped table-hover table-sm mb-0">
                                <thead class="bg-silver font-weight-bold">
                                    <tr>
                                        <td>Method</td>
                                        <td>{{theCurrency.code.toUpperCase()}}</td>
                                        <td>Days</td>
                                    </tr>
                                </thead>
                                <tr v-if="shippingMethodsFee && shippingMethodsFee.express">
                                    <td>
                                        <label :for="`${item._id}_express`" class="clickable d-block">
                                            <input 
                                                v-model="shippingMethod" 
                                                @click="selectedShippingMethodFxn('express', shippingMethodsFee.express)" 
                                                value="express" type="radio" name="" 
                                                :id="`${item._id}_express`"> Express
                                        </label>
                                    </td>
                                    <td>{{shippingMethodsFee.express * theCurrency.rate | money}}</td>
                                    <td>{{shippingMethodsFee.expressDays}}</td>
                                </tr>
                                <tr v-if="shippingMethodsFee && shippingMethodsFee.economy">
                                    <td>
                                        <label :for="`${item._id}_economy`" class="clickable d-block">
                                            <input 
                                                v-model="shippingMethod" 
                                                @click="selectedShippingMethodFxn('economy', shippingMethodsFee.economy)" 
                                                value="economy" type="radio" name="" 
                                                :id="`${item._id}_economy`"> Economy
                                        </label>
                                    </td>
                                    <td>{{shippingMethodsFee.economy * theCurrency.rate | money}}</td>
                                    <td>{{shippingMethodsFee.economyDays}}</td>
                                </tr>
                                <tr v-if="shippingMethodsFee && shippingMethodsFee.budget">
                                    <td>
                                        <label :for="`${item._id}_budget`" class="clickable d-block">
                                            <input 
                                                v-model="shippingMethod" 
                                                @click="selectedShippingMethodFxn('budget', shippingMethodsFee.budget)" 
                                                value="budget" type="radio" name="" 
                                                :id="`${item._id}_budget`"> Budget
                                        </label>
                                    </td>
                                    <td>{{shippingMethodsFee.budget * theCurrency.rate | money}}</td>
                                    <td>{{shippingMethodsFee.budgetDays}}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <label :for="`${item._id}_pickup`" class="clickable d-block">
                                            <input 
                                                v-model="shippingMethod" 
                                                @click="selectedShippingMethodFxn('pickup', '0')" 
                                                value="pickup" type="radio" name="" 
                                                :id="`${item._id}_pickup`"> Pickup
                                        </label>
                                    </td>
                                    <td>0</td>
                                    <td>ASAP</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ItemPhoto from '@/components/general/shared/ItemParts/ItemPhoto.vue'
import ItemPrice from '@/components/general/shared/ItemParts/ItemPrice.vue'

export default {
    name: "ShippingItem",
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            shippingMethod: '',
            shippingMethodsFee: null
        }
    },
    methods: {
        ...mapActions(['fetchShippingMethodFeesAction']),
        fetchShippingMethodFeesFxn(theItemObj) {
            if(!theItemObj.subCategory) return
            let itemSubCategoryObj = {
                categoryName: theItemObj.category,
                subCategoryName: theItemObj.subCategory,
            }
            this.fetchShippingMethodFeesAction(itemSubCategoryObj)
            .then((data) => {
                if(data && !data.error && data.result){
                    // assign the fees and days object to be displayed
                    this.shippingMethodsFee = data.result.shippingFees
                }
            })
            .catch((e) => {})
        },
        selectedShippingMethodFxn(selectedMethod, methodPrice) {
            if(!selectedMethod || !methodPrice) return
            // check if user already have a add-to-cart items storage on local-storage
            let localStorageATCItemIds = JSON.parse(localStorage.getItem('ani_items_atc')) 
            if(localStorageATCItemIds && localStorageATCItemIds.length) {
                // fetch and update the local storage cart item with the shipping details value
                let existingCartItemIndex = localStorageATCItemIds.findIndex(cartItem => cartItem.itemId === this.item._id)
                if(existingCartItemIndex !== -1){
                    let existingCartItemObj = localStorageATCItemIds[existingCartItemIndex]
                    existingCartItemObj.shippingMethod = selectedMethod
                    existingCartItemObj.shippingPrice = parseInt(methodPrice)
                    localStorageATCItemIds.splice(existingCartItemIndex, 1, existingCartItemObj)
                    localStorage.setItem('ani_items_atc', JSON.stringify(localStorageATCItemIds))
                } 
            }
        },
        obtainItemShipping() {
            // check if user already have a add-to-cart items storage on local-storage
            let localStorageATCItemIds = JSON.parse(localStorage.getItem('ani_items_atc')) 
            if(localStorageATCItemIds && localStorageATCItemIds.length) {
                // fetch the users preffered shipping method for the item
                let cartItemDetails = localStorageATCItemIds.find(cartItem => cartItem.itemId === this.item._id)
                if(cartItemDetails){
                    this.shippingMethod = cartItemDetails.shippingMethod
                } 
            }
        }
    },
    computed: {
        ...mapGetters(['setCurrency']),
        theCurrency() {
            if(this.setCurrency) {
                return this.setCurrency
            }
            return false
        },
    },
    components: {
        appItemPhoto: ItemPhoto,
        appItemPrice: ItemPrice,
    },
    watch: {
        item(){
            this.fetchShippingMethodFeesFxn(this.item)
        }
    },
    created() {
        this.fetchShippingMethodFeesFxn(this.item)
        this.obtainItemShipping()
    }
}
</script>
